import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { TextField, Tooltip } from "@mui/material"
import NumberFormat from "react-number-format"
// import moment from "moment/moment"

// import iconCandado from '../../img/tabla/iconCandado.svg'

import { iniChangeItemsChecked, iniChangeItemsDate, iniChangeItemsInside, iniChangeItemsUnidad, iniChangeTotales } from "../../../../redux/actions/pptos"
import { DialogDetailItems } from "../DialogDetailItems"

import { ItemsActions } from "../ItemsActions"
import { AutocompleteServicios } from "../AutocompleteServicios"
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers"
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { Link } from "react-router-dom"

export const TablaPptosItems = ({ subDetailPpto, index, handleKey, indexTitle, estado_negocio, unidadMedida, handleOpenListCompras }) => {

    const dispatch = useDispatch()
    const { access } = useSelector(state => state.auth)
    const { detail } = useSelector(state => state.ppto)
    const { separacion_miles, separacion_decimales, simbolo, items, reading_mode, margen_sobre_costo } = detail
    const { services } = useSelector(state => state.general)

    const { ppto_items_mostrar_fechas, ppto_items_ocultar_dias, ppto_items_ocultar_dscto, ppto_cant_decimales } = useSelector(state => state.general.detail)

    const [openDialogDetailItem, setOpenDialogDetailItem] = useState(false)


    const handleChange = (values, target) => {
        if (!values.sourceInfo.event) return false
        dispatch(iniChangeItemsInside(items, target, values, subDetailPpto, margen_sobre_costo))
        dispatch(iniChangeTotales(detail, items))
    }

    const handleChangeChecked = (e) => {
        dispatch(iniChangeItemsChecked(items, e.target.checked, subDetailPpto));
    }

    const handleChangeUnidad = (e) => {
        const valueUnidad = e.target.value
        dispatch(iniChangeItemsUnidad(items, valueUnidad, subDetailPpto));
    }

    // const handleChangeDate = (e) => {

    //     const objfecha = {
    //         name: e.target.name,
    //         value: e.target.value
    //     }

    //     dispatch(iniChangeItemsDate(items, objfecha, subDetailPpto));
    // }

    const handleChangeDate2 = (targetName, value) => {
        console.log(targetName, value)

        const objfecha = {
            name: targetName,
            value: value
        }

        dispatch(iniChangeItemsDate(items, objfecha, subDetailPpto));
    }

    return (
        <>
            {openDialogDetailItem &&
                <DialogDetailItems
                    open={openDialogDetailItem}
                    setOpen={setOpenDialogDetailItem}
                    item={subDetailPpto}
                />
            }

            <tr className="p-item">
                {!reading_mode &&
                    <td className="p-col-medium border-right-separate">
                        <div className="d-flex justify-content-between align-items-center">
                            {subDetailPpto.ocultar_item_print ?
                                <Tooltip title="Ítem oculto en pdf">
                                    <i
                                        className="bi bi-eye-slash ms-1"
                                        style={{
                                            color: '#8f24aa',
                                            fontSize: '16px'
                                        }}
                                    ></i>
                                </Tooltip>
                                :
                                <span className="ms-2" style={{ color: 'transparent' }}>--</span>
                            }
                            <span className="ms-2" style={{ color: 'transparent' }}>--</span>
                            <ItemsActions
                                item={subDetailPpto}
                                showAddTitle_={false}
                                showAddItem_={false}
                            />
                        </div>
                    </td>
                }

                <td className="p-col-x-large border-right-separate_ sticky left-0 bg-white z-10 px-4 py-2 border">
                    <div className="AutocompleteListDetail d-flex justify-content-between align-items-center">
                        <AutocompleteServicios
                            itemsOptions={services}
                            item={subDetailPpto}
                            id={`${index}${indexTitle}autoComplete`}
                            handleKey={handleKey}
                            index={index}
                            indexTitle={indexTitle}
                            nombreInput='autoComplete'
                            idTitulo={subDetailPpto.id_titulo}
                        />
                        {(subDetailPpto.nombre !== null && subDetailPpto.nombre !== '') &&
                            <Tooltip title="Detalle servicio">
                                <i
                                    style={{
                                        cursor: 'pointer',
                                        color: (subDetailPpto.descripcion_larga && subDetailPpto.descripcion_larga !== '') ? '#8E24AA' : '',
                                        fontSize: '12px',
                                        marginLeft: '10px'
                                    }}
                                    data-bs-toggle="tooltip"
                                    ata-bs-placement="top"
                                    data-bs-title="Tooltip on top"
                                    className="bi bi-card-text"
                                    onClick={() => setOpenDialogDetailItem(true)}
                                ></i>
                            </Tooltip>
                        }
                    </div>
                </td>
                <td className="p-col-small">
                    <NumberFormat
                        className='p-cantidades-item-new text-center'
                        value={subDetailPpto.cant}
                        prefix={''}
                        onKeyDown={(e) => handleKey(e, index, indexTitle, 'cant', subDetailPpto.id_titulo)}
                        id={`${index}${indexTitle}cant`}
                        onValueChange={(values, sourceInfo) => handleChange({ ...values, sourceInfo }, 'cant')}
                        disabled={reading_mode}
                    />
                </td>

                {!ppto_items_ocultar_dias &&
                    <td className="p-col-small">
                        <NumberFormat
                            className='p-cantidades-item-new text-center'
                            value={subDetailPpto.dias}
                            prefix={''}
                            onKeyDown={(e) => handleKey(e, index, indexTitle, 'dias', subDetailPpto.id_titulo)}
                            id={`${index}${indexTitle}dias`}
                            onValueChange={(values, sourceInfo) => handleChange({ ...values, sourceInfo }, 'dias')}
                            disabled={reading_mode}
                        />
                    </td>
                }

                <td className="p-col-small text-center">
                    <select
                        className="p-cantidades-item-new text-center"
                        onChange={handleChangeUnidad}
                    >
                        {unidadMedida?.map(it => {
                            if (subDetailPpto.unidad_medida === it.nombre) {
                                return <option value={it.nombre} selected>{it.nombre}</option>
                            } else {
                                return <option value={it.nombre}>{it.nombre}</option>
                            }
                        })}
                    </select>
                </td>

                {/* precio_unitario */}
                <td className="p-col-medium text-end">
                    <NumberFormat
                        className='p-cantidades-item-new'
                        value={subDetailPpto.precio_unitario}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        prefix={`${simbolo} `}
                        onKeyDown={(e) => handleKey(e, index, indexTitle, 'precio_unitario', subDetailPpto.id_titulo)}
                        id={`${index}${indexTitle}precio_unitario`}
                        onValueChange={(values, sourceInfo) => handleChange({ ...values, sourceInfo }, 'precio_unitario')}
                        disabled={reading_mode}
                        decimalScale={ppto_cant_decimales || 2}
                        fixedDecimalScale
                    />
                </td>

                {/* pre_subtotal_precio */}
                {!ppto_items_ocultar_dscto &&
                    <td className="p-col-medium p-bg-cliente text-end">
                        <NumberFormat
                            className='cantidades-item-new'
                            value={subDetailPpto.pre_subtotal_precio}
                            displayType={'text'}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale
                        />
                        <Tooltip title="valor calculado, no modificable">
                            <i className="bi bi-lock p-icon-block"></i>
                        </Tooltip>
                    </td>
                }

                {/* dscto */}
                {!ppto_items_ocultar_dscto &&
                    <td className="p-col-medium text-end">
                        <NumberFormat
                            className='p-cantidades-item-new'
                            value={subDetailPpto.descuento}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            onKeyDown={(e) => handleKey(e, index, indexTitle, 'descuento', subDetailPpto.id_titulo)}
                            id={`${index}${indexTitle}precio_unitario`}
                            onValueChange={(values, sourceInfo) => handleChange({ ...values, sourceInfo }, 'descuento')}
                            disabled={reading_mode}
                            decimalScale={ppto_cant_decimales || 2}
                            fixedDecimalScale
                        />
                    </td>
                }

                {/* precio_subtotal */}
                <td className="p-col-medium p-bg-cliente border-right-separate text-end">
                    <NumberFormat
                        className='cantidades-item-new'
                        value={subDetailPpto.precio_subtotal}
                        displayType={'text'}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        prefix={`${simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale
                    />
                    <Tooltip title="valor calculado, no modificable">
                        <i className="bi bi-lock p-icon-block"></i>
                    </Tooltip>
                </td>

                {/* costo_unitario */}
                {access.a20 &&
                    <td className="p-col-medium text-end">
                        <NumberFormat
                            className='p-cantidades-item-new'
                            value={subDetailPpto.costo_unitario}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            onKeyDown={(e) => handleKey(e, index, indexTitle, 'costo_unitario', subDetailPpto.id_titulo)}
                            id={`${index}${indexTitle}costo_unitario`}
                            onValueChange={(values, sourceInfo) => handleChange({ ...values, sourceInfo }, 'costo_unitario')}
                            disabled={reading_mode}
                            decimalScale={ppto_cant_decimales || 2}
                            fixedDecimalScale
                        />
                    </td>
                }

                {/* costo_subtotal */}
                {access.a20 &&
                    <td className="p-col-medium bg-col-subtotal-costos border-right-separate">
                        <div className={`d-flex align-items-center ${subDetailPpto.id_proveedor ? 'justify-content-between' : 'justify-content-end'}`}>

                            {(parseInt(subDetailPpto.id_proveedor) > 0 && subDetailPpto.nombre_proveedor !== null) ?
                                <Tooltip title={`Proveedor: ${subDetailPpto.nombre_proveedor}`}>
                                    <i className="bi bi-person" style={{ color: '#8E24AA', cursor: 'pointer', fontSize: '11px' }}></i>
                                </Tooltip>
                                : <span></span>
                            }

                            <div className="d-flex justify-content-center align-items-center text-end">
                                <NumberFormat
                                    className='p-cantidades-item-new p-no-border'
                                    value={subDetailPpto.costo_subtotal}
                                    displayType={'text'}
                                    thousandSeparator={separacion_miles}
                                    decimalSeparator={separacion_decimales}
                                    prefix={`${simbolo} `}
                                    decimalScale={2}
                                    fixedDecimalScale
                                />
                                <Tooltip title="valor calculado, no modificable">
                                    <i className="bi bi-lock p-icon-block"></i>
                                </Tooltip>
                            </div>

                        </div>
                    </td>
                }

                {/* utilidad ppto */}
                {access.a21 &&
                    <td className="p-col-medium bg-col-rent-esp text-end">
                        <NumberFormat
                            className='p-cantidades-item-new p-no-border'
                            value={subDetailPpto.margen_monto}
                            displayType={'text'}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale
                        />
                        <Tooltip title="valor calculado, no modificable">
                            <i className="bi bi-lock p-icon-block"></i>
                        </Tooltip>
                    </td>
                }

                {access.a21 &&
                    <td className="p-col-small border-right-separate">
                        <NumberFormat
                            className='p-cantidades-item-new'
                            value={subDetailPpto.margen_porcentaje}
                            suffix="%"
                            onKeyDown={(e) => handleKey(e, index, indexTitle, 'margen_porcentaje', subDetailPpto.id_titulo)}
                            id={`${index}${indexTitle}margen_porcentaje`}
                            onValueChange={(values, sourceInfo) => handleChange({ ...values, sourceInfo }, 'margen_porcentaje')}
                            disabled={reading_mode}
                            decimalScale={2}
                            fixedDecimalScale
                        />
                    </td>
                }

                {/* modo negocio - actual */}
                {estado_negocio === 'aprobado' &&
                    <>
                        {access.a21 &&
                            <>
                                <td className="p-col-medium text-end bg-col-gr border-right-separate d-flex flex-column">
                                    <Link
                                        to=""
                                        onClick={() => handleOpenListCompras('item', subDetailPpto)}
                                        className="p-link-open-dialog"
                                    >
                                        <NumberFormat
                                            className='p-cantidades-item-new p-no-border'
                                            value={subDetailPpto.total_gasto_real || 0}
                                            displayType={'text'}
                                            thousandSeparator={separacion_miles}
                                            decimalSeparator={separacion_decimales}
                                            prefix={`${simbolo} `}
                                            decimalScale={2}
                                            fixedDecimalScale
                                        />
                                        <Tooltip title="valor calculado, no modificable">
                                            <i className="bi bi-lock p-icon-block"></i>
                                        </Tooltip>
                                    </Link>
                                </td>
                                <td className={`p-col-medium text-end ${subDetailPpto.total_por_gastar < 0 ? 'p-excede-gasto' : ''} border-right-separate`}>
                                    <NumberFormat
                                        className='p-cantidades-item-new p-no-border'
                                        value={subDetailPpto.total_por_gastar || 0}
                                        displayType={'text'}
                                        thousandSeparator={separacion_miles}
                                        decimalSeparator={separacion_decimales}
                                        prefix={`${simbolo} `}
                                        decimalScale={2}
                                        fixedDecimalScale
                                    />
                                    <Tooltip title="valor calculado, no modificable">
                                        <i className="bi bi-lock p-icon-block"></i>
                                    </Tooltip>
                                </td>
                                <td className={`p-col-medium text-end ${subDetailPpto.total_por_gastar < 0 ? 'p-excede-gasto' : ''} border-right-separate`}>
                                    <NumberFormat
                                        className='p-cantidades-item-new p-no-border'
                                        value={subDetailPpto.margen_por_gastar || 0}
                                        displayType={'text'}
                                        suffix=" %"
                                        decimalScale={2}
                                        fixedDecimalScale
                                    />
                                    <Tooltip title="valor calculado, no modificable">
                                        <i className="bi bi-lock p-icon-block"></i>
                                    </Tooltip>
                                </td>
                            </>
                        }

                        {access.a22 &&
                            <>
                                <td className={`bg-col-ur p-col-medium text-end ${subDetailPpto.total_utilidad_real < 0 ? 'p-excede-gasto' : ''} border-right-separate`}>
                                    <NumberFormat
                                        className='p-cantidades-item-new p-no-border'
                                        value={subDetailPpto.total_utilidad_real || 0}
                                        displayType={'text'}
                                        thousandSeparator={separacion_miles}
                                        decimalSeparator={separacion_decimales}
                                        prefix={`${simbolo} `}
                                        decimalScale={2}
                                        fixedDecimalScale
                                    />
                                    <Tooltip title="valor calculado, no modificable">
                                        <i className="bi bi-lock p-icon-block"></i>
                                    </Tooltip>
                                </td>
                                <td className={`bg-col-ur p-col-medium text-end ${subDetailPpto.total_utilidad_real < 0 ? 'p-excede-gasto' : ''} border-right-separate`}>
                                    <NumberFormat
                                        className='p-cantidades-item-new p-no-border'
                                        value={subDetailPpto.margen_utilidad_real || 0}
                                        displayType={'text'}
                                        suffix=" %"
                                        decimalScale={2}
                                        fixedDecimalScale
                                    />
                                    <Tooltip title="valor calculado, no modificable">
                                        <i className="bi bi-lock p-icon-block"></i>
                                    </Tooltip>
                                </td>
                            </>
                        }

                    </>
                }

                {ppto_items_mostrar_fechas &&
                    <>
                        <td className="p-box-dates-small border-right-separate text-center">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DesktopDatePicker
                                    className="p-box-dates-small"
                                    label=""
                                    inputFormat="DD/MM/YYYY"
                                    name="fecha_inicio"
                                    value={subDetailPpto.fecha_inicio}
                                    onChange={(value) => handleChangeDate2('fecha_inicio', value)}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </td>
                        <td className="p-box-dates-small border-right-separate text-center">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DesktopDatePicker
                                    label=""
                                    inputFormat="DD/MM/YYYY"
                                    name="fecha_fin"
                                    value={subDetailPpto.fecha_fin}
                                    onChange={(value) => handleChangeDate2('fecha_fin', value)}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </td>
                    </>
                }

                <td className="p-col-small">
                    <div className="d-flex justify-content-center align-items-center">

                        {subDetailPpto.ocultar_item_print ?
                            <Tooltip title="Ítem oculto en pdf">
                                <i
                                    className="bi bi-eye-slash me-2"
                                    style={{
                                        color: '#8f24aa',
                                        fontSize: '16px'
                                    }}
                                ></i>
                            </Tooltip>
                            :
                            <span style={{ color: 'white' }}>---</span>
                        }

                        <label htmlFor={`check-select-${subDetailPpto.id}`} className="d-flex justify-content-center align-items-center">
                            <input
                                style={{ width: '15px', height: '15px' }}
                                type="checkbox"
                                id={`check-select-${subDetailPpto.id}`}
                                checked={subDetailPpto.selected}
                                onChange={handleChangeChecked}
                            />
                        </label>
                    </div>
                </td>

            </tr >
        </>
    )
}